export class Currency {
  currencyId!: number;
  currencyType!: string;
  constructor(source: Partial<Currency>) {
    Object.assign(this, source);
  }
}
